// A real form, posted the ordinary way, so a password manager offers to save it
// and so this page works with nothing else going right. The only JavaScript
// here reads the query string, because the pages have no templating and should
// not grow any for two messages.

/** The part of /api/whoami this page reads (web/auth.py api_whoami). */
interface WhoAmI {
  open: boolean;
  nobody?: boolean;
}

const byId = (id: string): HTMLElement => document.getElementById(id)!;

const q = new URLSearchParams(location.search);
if (q.has("bad")) byId("bad").hidden = false;
if (q.has("wait")) {
  byId("wait-min").textContent = q.get("wait");
  byId("wait").hidden = false;
}
const next = q.get("next") || "";
if (next.startsWith("/") && !next.startsWith("//")) {
  (byId("next") as HTMLInputElement).value = next;
}

// Not showWho(): this page has no top bar, and what it wants to know is
// different -- whether there is anybody to sign in as at all.
fetch("/api/whoami").then((r) => r.json() as Promise<WhoAmI>).then((who) => {
  if (who.open) {
    // Open: there is nothing to sign in to, and a way straight in.
    byId("nobody").hidden = false;
    byId("open-anyway").hidden = false;
  } else if (who.nobody) {
    // Nobody, and reachable from elsewhere: the form below cannot work yet,
    // so say why rather than letting somebody type into it.
    byId("shut").hidden = false;
  }
}).catch(() => {});
